export const participantKeys = {
  all: ['participants'] as const,
  list: (flowId: string) => [...participantKeys.all, flowId] as const,
  // Mutation key for delete mutations, scoped per flow. Concurrent
  // deletes in one flow share it (so the last-settled guard can
  // count them); deletes in other flows stay independent.
  delete: (flowId: string) =>
    [...participantKeys.all, 'delete', flowId] as const,
};
